import axios from "axios";
function SendNotification({ sid, userid, ticket_id, action }) {
  console.log("=== SendNotification Called ===");
  console.log("Params:", { sid, userid, ticket_id, action });

  if (!sid || !userid || !ticket_id) {
    console.error("SendNotification: Missing required params!", { sid, userid, ticket_id });
    return;
  }

  axios
    .post("https://topschool.prisms.in/rest/index.php/user_list.json", {
      fun_name: "TicketNotif",
      sid,
      userid,
      ticket_id,
      action,
    })
    .then((response) => {
      console.log("Notification API Response:", JSON.stringify(response.data));
      console.log("Notification sent successfully for ticket #" + ticket_id + " to user " + userid);
    })
    .catch((error) => {
      console.error("Notification failed for ticket #" + ticket_id + ":", error.message);
      console.error("Error details:", error.response ? error.response.data : "No response");
    });
}
export { SendNotification };
